import React from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const ClassItem = (props) => {
  const { lalaClass } = props;

  return (
    <Card className="border-0 shadow-sm h-100">
      {/* Image */}
      <div
        style={{
          backgroundImage: `url(${lalaClass.backgroundImageUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "220px",
          borderTopLeftRadius: "0.375rem",
          borderTopRightRadius: "0.375rem",
        }}
      />

      <Card.Body className="text-center px-4 py-4">
        {/* Title */}
        <Card.Title
          className="mb-3"
          style={{
            fontSize: "1.1rem",
            fontWeight: 600,
            letterSpacing: "0.5px",
          }}
        >
          {lalaClass.title}
        </Card.Title>

        {/* Description */}
        <Card.Text
          className="mb-4"
          style={{
            fontSize: "0.95rem",
            color: "#555",
            lineHeight: 1.6,
          }}
        >
          {lalaClass.shortDescription}
        </Card.Text>

        {/* CTA */}
        <Link
          to={{
            pathname: `/membersite/class/${lalaClass._id}`,
            lalaClass: lalaClass,
          }}
        >
          <Button size="sm" className="mainButton px-4">
            Ver más
          </Button>
        </Link>
      </Card.Body>
    </Card>
  );
};

export default ClassItem;